import DateRangeIcon from '@mui/icons-material/DateRange';
import { Box, TextField, useTheme } from '@mui/material';
import { createFieldStyles, createLabelProps, FONT_SIZE } from './filter-date-styles';
import { ToggleButton } from './toggle-button';

interface SingleDateFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  hasValue: boolean;
  allowToggle: boolean;
  onToggle: () => void;
}

export const SingleDateField = ({
  label,
  value,
  onChange,
  hasValue,
  allowToggle,
  onToggle,
}: SingleDateFieldProps) => {
  const theme = useTheme();

  const fieldStyle = createFieldStyles(theme, { hasValue });
  const labelProps = createLabelProps(theme, { hasValue });

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <TextField
        label={label}
        type="date"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        size="small"
        InputLabelProps={labelProps}
        inputProps={{ sx: { fontSize: FONT_SIZE } }}
        sx={{
          ...fieldStyle,
          flex: allowToggle ? 1 : undefined,
          minWidth: allowToggle ? 0 : undefined,
          width: allowToggle ? undefined : '100%',
        }}
      />
      <ToggleButton
        tooltipTitle="Switch to date range"
        IconComponent={DateRangeIcon}
        onClick={onToggle}
        show={allowToggle}
      />
    </Box>
  );
};
